import moment from 'moment';

export const EXPIRY_WARN_DAYS = 30;

// The compliance dates a bus carries - each one is flagged in the Buses list once it's expired or
// close to it, so an admin spots a lapsed insurance/fitness/permit/pollution cert at a glance.
export const BUS_DOC_FIELDS = [
  { key: 'insuranceExpiryDate', label: 'Insurance' },
  { key: 'fitnessExpiryDate', label: 'Fitness' },
  { key: 'permitExpiryDate', label: 'Permit' },
  { key: 'pollutionExpiryDate', label: 'Pollution' },
];

export const BUS_STATUS_OPTIONS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
  { label: 'Under maintenance', value: 'UNDER_MAINTENANCE' },
];

export const FUEL_OPTIONS = ['Diesel', 'Petrol', 'CNG', 'Electric'].map(f => ({ label: f, value: f }));

// -> { state: 'expired' | 'soon', days } or null when the date is missing / comfortably in future.
export const expiryState = dateStr => {
  if (!dateStr) return null;
  const days = moment(dateStr).startOf('day').diff(moment().startOf('day'), 'days');
  if (days < 0) return { state: 'expired', days };
  if (days <= EXPIRY_WARN_DAYS) return { state: 'soon', days };
  return null;
};

// Backend sends/accepts date-only fields as 'YYYY-MM-DD' strings.
export const toDateString = date => (date ? moment(date).format('YYYY-MM-DD') : '');

// A route's stops, nearest to the school first (stops without a distance go last, in the order they were added).
export const orderStops = areas =>
  [...(areas || [])].sort(
    (a, b) => (a.distance ?? Infinity) - (b.distance ?? Infinity) || a.transportAreaId - b.transportAreaId
  );

export const busLabel = bus =>
  bus ? `${bus.busNumber}${bus.seatingCapacity ? ` (${bus.seatingCapacity} seats)` : ''}` : '';
